var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { pushGaData, SingleConcurrentRequestController } from '../../common';
export const notificationGa = (eventLabel) => ({
    event: 'AutoEvent',
    eventCategory: 'Navigation',
    eventAction: 'Notification',
    eventLabel
});
export default class NotificationStore {
    constructor(rootStore) {
        Object.defineProperty(this, "notifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { notificationTemplates: [] }
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sectionStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "clickController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "readController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "requestConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { withCredentials: true }
        });
        Object.defineProperty(this, "fetchNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (customerId) => {
                if (!customerId) {
                    this.notifications = { notificationTemplates: [] };
                    return Promise.resolve();
                }
                this.status = 'FETCHING';
                const url = this.rootStore.environmentStore.URLData.getNotificationsURL('/notifications/get');
                try {
                    this.notifications = await this.getController.get(url, this.requestConfig);
                    this.status = 'FETCHED';
                }
                catch (e) {
                    this.status = 'ERROR';
                    this.notifications = { notificationTemplates: [] };
                }
            }
        });
        Object.defineProperty(this, "markAsClicked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (id) => {
                try {
                    const url = this.rootStore.environmentStore.URLData.getNotificationsURL(`/notifications/click/${id}`);
                    this.clickController.put(url, null, this.requestConfig);
                }
                catch (e) {
                }
            }
        });
        Object.defineProperty(this, "markAsRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (ids) => {
                if (!ids) {
                    ids = this.unreadMessageIds();
                }
                try {
                    const url = this.rootStore.environmentStore.URLData.getNotificationsURL('/notifications/read');
                    this.readController.put(url, { notificationIds: ids }, {
                        ...this.requestConfig,
                        headers: { 'Content-Type': 'application/json' }
                    });
                }
                catch (e) {
                }
                this.notifications.notificationTemplates.forEach((nt) => nt.customerNotifications.forEach((cn) => runInAction(() => ids.includes(cn.customerNotificationId) && (cn.read = true))));
            }
        });
        Object.defineProperty(this, "unreadMessageIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.notifications.notificationTemplates.reduce((unread, template) => {
                    unread = unread.concat(template.customerNotifications.reduce((u, cn) => {
                        if (!cn.read) {
                            u.push(cn.customerNotificationId);
                        }
                        return u;
                    }, []));
                    return unread;
                }, []);
            }
        });
        Object.defineProperty(this, "postGaData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (section) => {
                if (section === 'notifications') {
                    this.notifications.notificationTemplates.forEach((nt) => {
                        pushGaData(notificationGa(`Show - ${nt.type}`));
                    });
                }
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.ssoStore = rootStore.ssoStore;
        this.sectionStore = rootStore.sectionStore;
        reaction(() => { var _a, _b; return (_b = (_a = this.ssoStore.authData) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.customerId; }, (customerId) => this.fetchNotifications(customerId), { fireImmediately: true });
        reaction(() => this.sectionStore.section, this.postGaData);
    }
    get totalUnread() {
        return this.notifications.notificationTemplates.reduce((unread, template) => {
            unread += template.customerNotifications.reduce((u, cn) => {
                u += !cn.read ? 1 : 0;
                return u;
            }, 0);
            return unread;
        }, 0);
    }
}
__decorate([
    observable
], NotificationStore.prototype, "notifications", void 0);
__decorate([
    observable
], NotificationStore.prototype, "status", void 0);
__decorate([
    action
], NotificationStore.prototype, "fetchNotifications", void 0);
__decorate([
    action
], NotificationStore.prototype, "markAsRead", void 0);
__decorate([
    computed
], NotificationStore.prototype, "totalUnread", null);
//# sourceMappingURL=NotificationStore.js.map